var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8134_69932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 21.5224C35 24.5296 32.5635 26.9661 29.5563 26.9661H0V5.44371C0 2.4365 2.4365 0 5.44371 0H35V21.5224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3638 16.0018H27.6137C27.6795 16.0018 27.8222 15.9909 27.8771 15.9799C28.3051 15.8811 28.6673 15.508 28.6673 14.9811C28.6673 14.4543 28.3051 14.0702 27.8771 13.9824C27.8112 13.9714 27.6795 13.9604 27.6137 13.9604H25.3638V16.0018Z",
    fill: "url(#paint0_linear_8134_69932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3503 1.81091C25.1992 1.81091 23.4651 3.55597 23.4651 5.69614V9.73503H28.9637C29.0954 9.73503 29.249 9.746 29.3478 9.746C30.588 9.81185 31.5099 10.4484 31.5099 11.5569C31.5099 12.4349 30.8843 13.1703 29.7429 13.3459V13.3898C31.0051 13.4776 31.9709 14.169 31.9709 15.2665C31.9709 16.4519 30.9063 17.2092 29.5015 17.2092H23.4651V25.1333H29.1722C31.3233 25.1333 33.0574 23.3882 33.0574 21.248V1.81091H27.3503Z",
    fill: "url(#paint1_linear_8134_69932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4039 11.8533C28.4039 11.3374 28.0417 10.9972 27.6247 10.9204C27.5808 10.9094 27.482 10.8984 27.4052 10.8984H25.3638V12.7972H27.4052C27.482 12.7972 27.5917 12.7862 27.6247 12.7752C28.0527 12.7093 28.4039 12.3691 28.4039 11.8533Z",
    fill: "url(#paint2_linear_8134_69932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83884 1.81091C3.6877 1.81091 1.95361 3.55597 1.95361 5.69614V15.2995C3.04016 15.8263 4.17061 16.1775 5.32301 16.1775C6.67296 16.1775 7.4083 15.3543 7.4083 14.2568V9.746H10.7557V14.2568C10.7557 16.0238 9.6692 17.4396 5.95957 17.4396C3.72062 17.4396 1.96459 16.9567 1.96459 16.9567V25.1552H7.67171C9.82285 25.1552 11.5569 23.4102 11.5569 21.27V1.81091H5.83884Z",
    fill: "url(#paint3_linear_8134_69932)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5945 1.81091C14.4433 1.81091 12.7092 3.55597 12.7092 5.69614V10.7886C13.697 9.94356 15.3982 9.41675 18.1639 9.53747C19.6456 9.60332 21.215 9.99843 21.215 9.99843V11.6447C20.4248 11.2496 19.4809 10.8765 18.2737 10.7886C16.1774 10.635 14.9043 11.6557 14.9043 13.4776C14.9043 15.2995 16.1664 16.3202 18.2737 16.1665C19.4919 16.0787 20.4468 15.6946 21.215 15.3104V16.9567C21.215 16.9567 19.6456 17.3518 18.1639 17.4177C15.3982 17.5384 13.697 17.0116 12.7092 16.1665V25.1442H18.4163C20.5675 25.1442 22.3016 23.3992 22.3016 21.259V1.81091H16.5945Z",
    fill: "url(#paint4_linear_8134_69932)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8134_69932",
    x1: 23.4628,
    y1: 14.9801,
    x2: 33.0802,
    y2: 14.9801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#008D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#4FAC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8134_69932",
    x1: 23.4627,
    y1: 13.4815,
    x2: 33.0804,
    y2: 13.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#008D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#4FAC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8134_69932",
    x1: 23.4628,
    y1: 11.8502,
    x2: 33.0796,
    y2: 11.8502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#008D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#4FAC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8134_69932",
    x1: 1.93211,
    y1: 13.4815,
    x2: 11.6982,
    y2: 13.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#005999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#006FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8134_69932",
    x1: 12.6461,
    y1: 13.4815,
    x2: 22.131,
    y2: 13.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#8C3039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE273F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DF1E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1846"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8134_69932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 26.9661,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.bf1149023c6cd1f63c1ee5a1b95ac139.svg";
export { ForwardRef as ReactComponent };